/* tslint:disable */

/**
 */
export class MonetaryCurrency {
    ID_MONETARY_CURRENCY?: number;
    MONEY_TEXT?: string;
    MONEY_SYMB?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/monetary-currency.ts